<template>
    <!-- @mouseup="onTapStop($event)" -->
    <!-- v-on-click-outside.static="deselect" -->
    <div
        class="vue-selection"
        @mousedown="onTapStart($event)"
        v-on-click-outside.static="deselect">

        <!-- ICONS -->
        <slot :selectedStore="selectedStore" />

        <!-- SELECTION AREA -->
        <div class="vue-selection-area"
             :style="selectionAreaStyle"
             ref="selectionArea">
        </div>
    </div>
</template>

<script>
    // https://github.com/Simonwep/selection/blob/master/src/selection.js
    import * as event from './events';
    import * as _ from './utils';
    import { mixin as onClickOutside } from 'vue-on-click-outside';

    // Does this have performance gains?
    const abs = Math.abs,
          max = Math.max,
          min = Math.min,
          preventDefault = ev => ev.preventDefault();

    export default {
        name: 'vue-selection',
        mixins: [
            onClickOutside
        ],
        props: {
            settings: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                areaElement: null,
                boundaries: null,
                lastX: null,
                lastY: null,
                mouseDown: false,
                options: {},
                singleClick: false,
                selectables: [],
                selectedStore: [],
                inactiveStore: [], // inactive to the rescue
                selectionAreaStyle: {},
                targetBoundary: null, // ?
                touchedElements: null,
                changedElements: null,

                defaults: {
                    startThreshold: 10,
                    disableTouch: false,
                    containers: [],
                    selectables: ['.file-hitbox'],
                    // selectedClass: 'active', // previously in options.js
                    startareas: ['.vue-selection'], // html
                    boundaries: ['.vue-selection'] // html
                },
            }
        },
        watch: {
            selectedStore() {
                this.$emit('selected-items', this.selectedStore); // is watcher best?
            }
        },
        created() {
            this.options = Object.assign(this.defaults, this.settings);
        },
        mounted() {
            this.areaElement = this.$refs.selectionArea;
        },
        methods: {

            //-----------------------------------------------------------------
            // 01. TAP START - MOUSE DOWN
            //-----------------------------------------------------------------

            onTapStart(evt) {
                const touch = evt.touches && evt.touches[0];
                const startAreas = _.selectAll(this.options.startareas);
                const target = (touch || evt).target;
                const evtpath = _.eventPath(evt);
                const multiSelect = evt.shiftKey || evt.metaKey; // ctl or ⌘ key down --- DUPLICATION

                this.boundaries = _.selectAll(this.options.boundaries);

                if (!startAreas.find((el) => evtpath.includes(el)) ||
                    !this.boundaries.find((el) => evtpath.includes(el))) {
                    console.log('what does this do?')
                    return;
                }

                // Save start coordinates
                this.lastX = (touch || evt).clientX;
                this.lastY = (touch || evt).clientY;
                this.singleClick = true; // To detect single-click

                // // Create array of 'selectables'
                const containers = _.selectAll(this.options.containers);
                this.selectables = _.selectAll(this.options.selectables);
                containers.forEach(con => this.selectables.push(...con.getElementsByTagName('*')));

                // Save current boundary
                this.targetBoundary = this.boundaries.find((el) => _.intersects(el, target)).getBoundingClientRect();

                // [LOCKED] - flush
                this.inactiveStore = [];
                this.touchedElements = [];
                this.changedElements = {
                    added: [],
                    removed: []
                };

                // Prevent default selection
                this.$el.addEventListener('selectstart', preventDefault);

                //~~~~~~~~~~~~~~~~~~~
                // if target is NOT icons, allow drag multi-select
                if (evt.target == this.$el) {
                    console.log('target is not icon');

                    if (!multiSelect) {
                        this.clearSelection();
                    }
                    _.on(this.$el, 'mousemove', this.delayedTapMove);
                }
                //~~~~~~~~~~~~~~~~~~~

                _.on(this.$el, 'mouseup', this.onTapStop); //_.on(this.$el, 'mouseup', this.onTapStop);
                this.onSingleTap(evt);

            },

            //-----------------------------------------------------------------
            // 02. DELAYED TAP MOVE - MAY NOT
            // Check if drag is occuring, if so - update selection area
            //-----------------------------------------------------------------

            delayedTapMove(evt) {
                const touch = evt.touches && evt.touches[0];
                const x = (touch || evt).clientX;
                const y = (touch || evt).clientY;

                // Check pixel threshold
                if (abs((x + y) - (this.lastX + this.lastY)) >= this.options.startThreshold) {

                    _.off(this.$el, 'mousemove', this.delayedTapMove);

                    _.on(this.$el, 'mousemove', this.onTapMove);

                    _.css(this.areaElement, 'display', 'block');

                    // New start position
                    this.updateArea(evt);

                    // Fire event
                    const touched = this.touchedElements.concat(this.selectedStore);
                    const changed = this.changedElements;

                    // NO LONGER NECESSARY - as long as single click
                    // event.dispatchEvent(this, 'onStart', this.areaElement, evt, touched, changed);

                    // An action is recognized as single-select until
                    // the user performed an mutli-selection
                    this.singleClick = false;
                }
            },

            //-----------------------------------------------------------------
            // 03. ON TAP MOVE - triggered from delayedTapMove
            //-----------------------------------------------------------------

            onTapMove(evt) {
                this.updateArea(evt);
                this.updatedTouchingElements();
                const touched = this.touchedElements.concat(this.selectedStore);
                const changed = this.changedElements;
                // function in options
                event.dispatchEvent(this, 'onMove', this.areaElement, evt, touched, changed);
            },

            //-----------------------------------------------------------------
            // 04. ON TAP STOP (USUALLY MOUSE UP)
            // Cancels out drag, switches off listener
            //
            // invokes single tap, hides selection box
            //-----------------------------------------------------------------

            onTapStop(evt, noevent) {
                _.off(this.$el, 'mousemove', this.delayedTapMove);
                _.off(this.$el, 'mousemove', this.onTapMove);
                _.off(this.$el, 'mouseup', this.onTapStop);

                if (!this.singleClick && !noevent) {
                    this.updatedTouchingElements();
                    // const touched = this.touchedElements.concat(this.selectedStore); // necessary?
                    // const changed = this.changedElements;
                    this.keepSelection();
                }

                // Enable default selection
                this.$el.removeEventListener('selectstart', preventDefault);

                // disappear selection box
                _.css(this.areaElement, 'display', 'none');
            },

            //-----------------------------------------------------------------
            // 05. ON SINGLE TAP - called on stop
            // selected class, keep/clear/remove selection,
            //-----------------------------------------------------------------

            onSingleTap(evt) {
                const touch = evt.touches && evt.touches[0];
                // const target = (touch || evt).target;
                // const target = (touch || evt).target.parentElement;
                const target = (touch || evt).target.parentElement.parentElement;

                // console.log(target)

                // Check if the element is selectable
                if (!this.selectables.includes(target))
                    return;

                /* NEW CODE - HINT FOR SELF
                let {target} = _.simplifyEvent(evt); // this might be problematic

                // Traferse dom upwards to check if target is selectable
                while (!this.selectables.includes(target)) {
                    if (target.parentElement) {
                        target = target.parentElement;
                    } else {
                        return;
                    }
                }*/

                // console.log(target.__vue__);

                // Check if this element
                this.touchedElements.push(target);

                const touched = this.selectedStore;
                const changed = this.changedElements;
                const selected = target.classList.contains(this.options.selectedClass);
                const multiSelect = evt.shiftKey || evt.metaKey; // ctl or ⌘ key down

                // MULTI SELECT PRESSED DOWN
                if (multiSelect) {
                    if (!selected) {
                        target.classList.add(this.options.selectedClass);
                        this.keepSelection();
                    } else {
                        target.classList.remove(this.options.selectedClass);
                        this.removeFromSelection(target);
                    }
                } else {

                    //========================================
                    // USE CASE:
                    // don't unselect all if clicking on a 'selected'
                    // EG. group select then drag
                    //========================================

                    if (!selected) {
                        // unselect all
                        this.clearSelection();

                        // select this one
                        target.classList.add(this.options.selectedClass);
                        this.keepSelection();
                    }
                }
            },

            //-----------------------------------------------------------------
            // DESELECT - refactor, duplicated code
            //-----------------------------------------------------------------

            deselect(evt) {
                const multiSelect = evt.shiftKey || evt.metaKey; // ctl or ⌘ key down
                console.log('deselect')
                if (!multiSelect) {
                    this.selectedStore.forEach(item => {
                        item.classList.remove('active');
                        item.classList.add('inactive'); // this needs to be kept as reference
                    })
                    this.selectedStore = [];
                }
            },

            //-----------------------------------------------------------------
            // UPDATE AREA
            //-----------------------------------------------------------------

            updateArea(evt) {
                const brect = this.targetBoundary;
                const touch = evt.touches && evt.touches[0];
                let x2 = (touch || evt).clientX;
                let y2 = (touch || evt).clientY;

                if (x2 < brect.left) x2 = brect.left;
                if (y2 < brect.top) y2 = brect.top;
                if (x2 > brect.left + brect.width) x2 = brect.left + brect.width;
                if (y2 > brect.top + brect.height) y2 = brect.top + brect.height;

                const x3 = min(this.lastX, x2);
                const y3 = min(this.lastY, y2);
                const x4 = max(this.lastX, x2);
                const y4 = max(this.lastY, y2);

                this.selectionAreaStyle = {
                    top: y3 + 'px',
                    left: x3 + 'px',
                    width: x4 - x3 + 'px',
                    height: y4 - y3 + 'px'
                }
            },

            //-----------------------------------------------------------------
            // UPDATED TOUCHING ELEMENTS
            //-----------------------------------------------------------------

            updatedTouchingElements() {
                const touched = [];
                const changed = {
                    added: [],
                    removed: []
                };

                // Iterate over the selectable elements
                this.selectables.forEach(node => {

                        // Fire filter event
                        if (event.dispatchFilterEvent(this, 'selectionFilter', node) !== false) {

                            // Check if area intersects element
                            if (_.intersects(this.areaElement, node)) {

                                // Check if the element wasn't present in the last selection.
                                if (!this.touchedElements.includes(node)) {
                                    changed.added.push(node);
                                }

                                touched.push(node);
                            }
                        }
                    }
                );

                // Check which elements where removed since last selection
                changed.removed = this.touchedElements.filter(el => !touched.includes(el));

                // Save
                this.touchedElements = touched;
                this.changedElements = changed;
            },

            //-----------------------------------------------------------------
            // KEEP SELECTION
            // * Saves the current selection for the next selecion.
            // * Allows multiple selections.
            //-----------------------------------------------------------------

            keepSelection() {
                const keep = this.touchedElements.filter(x => !this.selectedStore.includes(x));
                this.selectedStore = keep.concat(this.selectedStore);
            },

            //-----------------------------------------------------------------
            // CLEAR SELECTION
            // Clear the elements which where saved by 'keepSelection()'.
            //-----------------------------------------------------------------

            clearSelection() {
                this.selectedStore.forEach(s => s.classList.remove(this.options.selectedClass, 'inactive')); // added
                this.selectedStore = [];
            },

            //-----------------------------------------------------------------
            // REMOVE FROM SELECTION
            // Removes a particular element from the selection.
            //-----------------------------------------------------------------

            removeFromSelection(el) {
                _.removeElement(this.selectedStore, el);
                _.removeElement(this.touchedElements, el);
            },

            //-----------------------------------------------------------------
            // CANCEL
            // Cancel the current selection process.
            // * @param  {boolean} true to fire the onStop listener after cancel.
            //-----------------------------------------------------------------

            // cancel(keepEvent) {
            //     this.onTapStop(null, !keepEvent);
            // },

            //-----------------------------------------------------------------
            // OPTION
            // Set or get an option.
            // * @param   {string} name
            // * @param   {*}      value
            // * @return  {*}      the new value
            //-----------------------------------------------------------------

            // option(name, value) {
            //     const options = this.options;

            //     // console.log('option')

            //     if (value === void 0)
            //         return options[name];

            //     return options[name] = value;
            // },

            //-----------------------------------------------------------------
            // DISABLE
            // Disable the selection functinality.
            //-----------------------------------------------------------------

            // disable() {
            //     _.off(this.$el, 'mousedown', this.onTapStart);
            // },

            //-----------------------------------------------------------------
            // DESTROY ?
            // Unbinds all events and removes the area-element
            //-----------------------------------------------------------------

            // destroy() {
            //     that.disable();
            //     doc.body.removeChild(that._areaElement);
            // },

            //-----------------------------------------------------------------
            // ENABLED
            // Enable the selection functionality.
            //-----------------------------------------------------------------

            // enable() {
            //     _.on(this.$el, 'mousedown', this.onTapStart);
            // }
        }
    }
</script>

<style lang="scss">
    .vue-selection {
        position: relative;
        // user-select: none;
        // background: orange;
        overflow: hidden;
      }

    .selected-store {
        position: fixed;
        bottom: 60px;
        left: 20px;
        z-index: 999;
        background: blue;
        color: white;
        padding: 5px;
    }

    .vue-selection-area {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(black, 0.1);
        border: 1px solid rgba(black, 0.15);
        // z-index: 99;
    }
</style>